import { storage } from '@landrover/business/index'
import { get } from 'lodash'
import { USER_LOGIN, USER_LOGOUT } from '../actions/users'

function usersReduers(
  state = storage.getItemSync('userInfo') ? JSON.parse(storage.getItemSync('userInfo')) : {},
  action
) {
  switch (action.type) {
    case USER_LOGIN:
      if (action.users) {
        storage.setItemSync('userInfo', JSON.stringify(get(action, 'users', {})))
      }
      return { ...state, ...get(action, 'users', {}) }
    case USER_LOGOUT:
      storage.removeItemSync('userInfo')
      return {}
    default:
      return state
  }
}

export default usersReduers
